import { createFileRoute } from '@tanstack/react-router';
import { PainelAdmSqlEditorPage } from '@/features/painel-administrativo/sql-editor/page/PainelAdmSqlEditorPage';

export const Route = createFileRoute('/admin/_a/sql-editor')({
    component: PainelAdmSqlEditorPage,
});
